import { LiftAccessRuleSetContext } from "../liftAccessRuleSet/models";
import {
  AccessRuleMultiContextDeleteRequest,
  buildMultiContextDeleteRequest,
} from "./accessRuleRequestBuilder";
import { getRequestUtcDateTime } from "./accessRuleRequestMapper";

/**
 * Builds the delete request for one rule set, sent to the endpoint a bulk run uses.
 *
 * Takes a rule set, not a list of contexts: callers read the outcome from the
 * loading/error pair alone, which only holds at one context — the endpoint returns
 * 200 iff that context succeeded, 400 iff it failed. With several, a partial success
 * returns 200 and reads as a full success.
 */
export function buildSingleRuleSetDeleteRequest({
  userId,
  operatorId,
  ruleSet,
}: {
  userId: string;
  operatorId: string;
  ruleSet: Pick<
    LiftAccessRuleSetContext,
    | "entitlementTypeId"
    | "fulfillmentSeasonId"
    | "scopeCategoryId"
    | "locationId"
  >;
}): AccessRuleMultiContextDeleteRequest {
  return buildMultiContextDeleteRequest({
    userId,
    operatorId,
    contexts: [
      {
        EntitlementTypeId: ruleSet.entitlementTypeId,
        FulfillmentSeasonId: ruleSet.fulfillmentSeasonId,
        LiftAccessRuleScopeCategory: ruleSet.scopeCategoryId,
        LiftAccessRuleScopeEntityId: ruleSet.locationId,
      },
    ],
    // A single delete is its own run, so it stamps its own time.
    requestUtcDateTime: getRequestUtcDateTime(),
  });
}
